import {connect} from 'pwa-helpers';
import {LitElement, html, css} from 'lit';
import {customElement} from 'lit/decorators/custom-element.js';
import {property} from 'lit/decorators/property.js';
import {classMap} from 'lit/directives/class-map.js';
import {when} from 'lit/directives/when.js';
import store from '../store';
import {setMedia, setSection} from '../slices/statusSlice';

import dot from '../../icons/dot';

@customElement('sections-tab')
export class SectionsTab extends connect(store)(LitElement) {

	static styles = css`
		.host {
		}

		button {
			display: flex;
			align-items: center;
			justify-content: flex-start;
			min-width: var(--nav-button-tab-width);
			height: 32px;
			color: var(--color-white);
			transition: border-bottom-width 0.2s ease-out, height 0.2s ease-out, border-bottom-color 0.4s, background-color 0.4s, color 0.4s;
			padding: 0;
			background-color: transparent;
			border: none;
			border-bottom: 2px solid var(--color-grey4);
			cursor: pointer;
		}
		@media (max-width: 768px) {
			button {
				min-width: 8px;
			}
		}
		button:hover {
			border-bottom-width: 4px;
		}

		button.selected {
			// height: 25px;
			border-bottom-width: 6px;
		}

		button.satisfied {
			border-bottom-color: var(--border-white);
		}
		button.disabled {
			pointer-events: none;
			border-bottom-color: var(--color-grey6);
		}

    `;

	@property({type: Boolean})
	selected = false;

	@property({type: Boolean})
	satisfied = false;

	@property({type: Number})
	percentage = 0;

	@property({type: String})
	label = '---';

	@property({type: String})
	key = '';

	@property({type: Boolean})
	disabled = false;

	constructor() {
		super();
		store.subscribe(() => this.requestUpdate());
	}


	setSection(e) {
		store.dispatch(setSection({currentSection: this.key}));
		store.dispatch(setMedia({media: 'sections'}));
	}

	render() {
		return html`
			<button @click=${this.setSection} class="${classMap({selected: this.selected, satisfied: this.satisfied, disabled: this.disabled})}" title=${this.label}></button>
		`;
	}
}
